import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FaCalendarAlt } from 'react-icons/fa';
import './CustomDateInput.scss';  // Custom CSS for styling
const CustomDateInput = ({ label, value, onChange }) => {
    const [selectedDate, setSelectedDate] = useState(null);

    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <p style={{ margin: 0 }}> {label}</p><div className="custom-date-picker">
                    <DatePicker
                        selected={value}
                        onChange={onChange}
                        // selected={selectedDate}
                        // onChange={(date) => setSelectedDate(date)}
                        dateFormat="dd/MM/yyyy"
                        className="date-input"
                        placeholderText="Select a date" />
                    <FaCalendarAlt className="calendar-icon" />
                </div>
            </div></>
    );
};

export default CustomDateInput;
